import { render, staticRenderFns } from "./GridButtonProviderUser.vue?vue&type=template&id=5637dd74&"
import script from "./GridButtonProviderUser.vue?vue&type=script&lang=js&"
export * from "./GridButtonProviderUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports